<template>
  <b-card>
    <div v-if="!loader">
      <b-row>
        <b-col
          v-for="(item , index) in bankAccountsData"
          :key="index"
          cols="12"
        >
          <div class="my-1">
            <div
              class="text-center py-2"
              :style="{ background: `${gradientColors}`, border: 'none', color: 'white' , fontSize: '18px', borderRadius: '10px 0px 10px 0px' }"
            >
              {{ item.office_name }} ({{ item.bank_accounts.currency }})
            </div>

            <b-card-body>
              <b-card-text><strong> Bank Balance: </strong> {{ item.bank_accounts.totals.bank_balance }} </b-card-text>
              <b-card-text><strong> Card Balance: </strong> {{ item.bank_accounts.totals.card_balance }} </b-card-text>
              <b-card-text><strong> Cash In Hand: </strong> {{ item.bank_accounts.totals.cash_in_hand }} </b-card-text>
              <b-card-text><strong> Total Balance: </strong> {{ item.bank_accounts.totals.total_balance }} </b-card-text>
              <b-card-text class="text-right">
                <b-card class="text-left">
                  <span v-if="item.bank_accounts.accounts.length > 0">
                    <b-table
                      small
                      :fields="fields"
                      :items="item.bank_accounts.accounts"
                      responsive="sm"
                      bordered
                      class="table-banks-accounts"
                      head-variant="dark"
                    >
                      <template #head(running_balance)>
                        <span> RUNNIG BALANCE (EGP) </span>
                      </template>
                    </b-table>
                  </span>
                  <span v-else>
                    no data available in this office
                  </span>
                </b-card>
              </b-card-text>
            </b-card-body>

            <PieChart
              :sources="item.sources"
              :total-income="item.total_income"
              :office-name="item.office_name"
            />

            <BarExpensesChart
              :sources="item.expense_types"
              :total-expenses="item.total_expenses"
              :office-name="item.office_name"
            />

            <BarBillsChart
              :sources="item.bills"
              :total-bills="item.total_bills"
              :office-name="item.office_name"
            />
          </div>

        </b-col>
      </b-row>
    </div>
    <div
      v-else
      class="text-center pt-5"
    >
      <LoadingBankAccount />
    </div>
  </b-card>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'
import PieChart from '../side-right-bar/charts-branchs/PieChart.vue'
import BarExpensesChart from '../side-right-bar/charts-branchs/BarExpensesChart.vue'
import BarBillsChart from '../side-right-bar/charts-branchs/BarBillsChart.vue'
import LoadingBankAccount from './LoadingBankAccount.vue'

export default {
  components: {
    PieChart, BarExpensesChart, BarBillsChart, LoadingBankAccount,
  },
  data() {
    return {
      loader: false,
      bankAccountsData: [],
      activeAccordion: null,
      gradientColors: 'linear-gradient( 135deg, #00a1f7 0%, #2575fc 40%, #2575fc 60%, #00a1f7 100%)',
      fields: [
        { key: 'account_name', label: 'Account Name' },
        { key: 'running_balance', label: 'Running Balance' },
        { key: 'account_type', label: 'Account Type' },
        { key: 'account_number', label: 'Account Number' },
      ],
    }
  },

  mounted() {
    this.getBankAccounts()
  },
  methods: {
    getBankAccounts() {
      this.loader = true
      const getOfficeId = localStorage.getItem('office_id')
      axios.get(`office-summary?office_id=${getOfficeId}`).then(res => {
        const { data } = decryptData(res.data.payload)
        this.bankAccountsData = data
      }).catch(error => {
        if (error.response.status) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.status === 403 ? "You don't have permission to do this." : error.response.data.message}`,
              icon: 'BellIcon',
              variant: 'error',
            },
          })
        }
      }).finally(() => {
        this.loader = false
      })
    },
    toggleIcon(index) {
      this.activeAccordion = this.activeAccordion === index ? null : index
    },
  },
}
</script>
<style>
.table-banks-accounts .table .thead-dark th{
    background-color: #1ea0fc;
    border-color: #1ea0fc;
    text-wrap: nowrap !important;
}
</style>
